import { render, staticRenderFns } from "./UniverseOverview.vue?vue&type=template&id=27906d76"
import script from "./UniverseOverview.vue?vue&type=script&lang=js"
export * from "./UniverseOverview.vue?vue&type=script&lang=js"
import style0 from "./UniverseOverview.vue?vue&type=style&index=0&id=27906d76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports